import {
    CLIENT_SESSIONS_REQUEST_GET,
    CLIENT_SESSIONS_RESPONSE_GET_SUCCESS,
    CLIENT_SESSIONS_RESPONSE_GET_FAIL,
    CLIENT_SESSIONS_HISTORY_REQUEST_GET,
    CLIENT_SESSIONS_HISTORY_RESPONSE_GET_SUCCESS,
    CLIENT_SESSIONS_HISTORY_RESPONSE_GET_FAIL,
    CLIENT_SESSIONS_HISTORY_RESET
  } from "../constants/clientSessionsConstants";
  
  export const clientSessionListReducer = (state = { clientSessions: {} ,
    clientSessionHistory : {historicalData: [], loading: false} 
  }, action) => {
    switch (action.type) {
      case CLIENT_SESSIONS_REQUEST_GET:
        return {
          ...state,
          loading: true,
        };
      case CLIENT_SESSIONS_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          clientSessions: action.payload,
        };
      case CLIENT_SESSIONS_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case CLIENT_SESSIONS_HISTORY_REQUEST_GET:
        return {
          ...state,
          clientSessionHistory : {
            loading: true
          },
        };
      case CLIENT_SESSIONS_HISTORY_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          clientSessionHistory : {
            historicalData : action.payload,
            loading: false,
            error : null
          }
        };
      case CLIENT_SESSIONS_HISTORY_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          clientSessionHistory : {
            historicalData : [],
            loading: false,
            error : action.payload
          }
        };
      case CLIENT_SESSIONS_HISTORY_RESET:
        return {
          ...state,
          clientSessionHistory : {
            historicalData : {},
            loading: false,
            error : null
          }
        };
      default:
        return state;
    }
  };